module.exports = __webpack_public_path__ + "static/timetravel_img4jpg-bf5b8678d87bbdea86eb8ac117efc17d.png";